import classNames from 'classnames';

import IconDownload from '../components/icons/IconDownload';
import IconPrint from '../components/icons/IconPrint';

const buttonClassNames =
  'w-full p-[25%] aspect-square bg-accent hover:bg-accent-light text-accent-text cursor-pointer not-last:mb-4 shadow--small transition-colors';

const Aside = () => (
  <aside className={classNames('print:hidden', 'fixed right-8 bottom-8', 'max-desktop:right-4 max-desktop:bottom-4')}>
    <nav className="flex flex-col gap-4 justify-end w-14 h-full">
      <a href="/files/marc_malignan_cv.pdf" download="Marc Malignan - CV.pdf">
        <button className={buttonClassNames} title="Télécharger PDF">
          <IconDownload />
        </button>
      </a>
      <button className={classNames(buttonClassNames, 'max-desktop:hidden')} title="Imprimer" onClick={() => window.print()}>
        <IconPrint />
      </button>
    </nav>
  </aside>
);

export default Aside;
